module.exports = __webpack_public_path__ + "img/imageContent28.358e4b89.jpg";